// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.balance{font-weight:500;color:#3b3a39}.balance--positive{color:#30bdef}`, "",{"version":3,"sources":["webpack://./src/components/Balance/style.scss","webpack://./src/style/variables.scss"],"names":[],"mappings":"AACA,SACE,eAAA,CACA,aC2DY,CDzDZ,mBACE,aC4FK","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
